import { Component, HostBinding, Input, ViewChild } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ModalWindowComponent } from 'ag-common-svc/lib/components/modal-window/modal-window.component';
import { PromptModals, PromptUserAction } from './prompt.model';
import { PromptService } from './prompt.service';
import { filter } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'ag-shr-prompt',
  templateUrl: './prompt.component.html',
  styleUrls: ['./prompt.component.scss'],
})
export class PromptComponent {
  @HostBinding('class') className = 'prompt';
  @ViewChild('promptModalRef', { static: false }) promptModalModalComponent: ModalWindowComponent;

  @Input() title: string = 'Apply Values';
  @Input() actionTitle: string = 'APPLY VALUE';
  @Input() modalId: PromptModals;

  constructor(private promptService: PromptService) {
    this.promptService.showModal$
      .pipe(
        untilDestroyed(this),
        filter(modalId => modalId && this.modalId === modalId),
      )
      .subscribe(() => {
        this.promptModalModalComponent.showModal();
      });
  }

  protected onApplyClick = () => {
    this.promptService.userAction$.next({
      modalId: this.modalId,
      type: PromptUserAction.apply,
    });
    this.promptModalModalComponent.hideModal();
  };

  protected onAbortClick = () => {
    this.promptService.userAction$.next({ modalId: this.modalId, type: PromptUserAction.abort });
    this.promptModalModalComponent.hideModal();
  };
}
